import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/vzv-shift`)
  return data.data
}

export const useVZVShifts = () => {
  const { data, ...props } = useQuery(
    queryKeys.VZV_SHIFTS,
    () => getData(),
  )
  return { data, ...props }
}
